export default __webpack_public_path__ + "static/media/ios_notification.d9c35ba3.mp3";